import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { ReactNode } from 'react';
import { To, useLocation, useNavigate } from 'react-router-dom';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { PATHS } from 'src/constants/paths';

import { Breadcrumbs, BreadcrumbsProps } from '../breadcrumbs';
import { LightTooltip } from '../settings/settingsCategory/SettingsCategory.styled';
import {
  ActionBarBox,
  HeaderTitle,
  HeaderWrapper,
  StyledBox,
  StyledGrid,
  StyledIconButton,
  StyledStack,
  StyledWrapper,
} from './Header.styled';

interface HeaderProps {
  actionBar?: React.ReactNode;
  icon?: ReactNode;
  iconText?: string;
  title?: string;
  backLink?: string | number;
  titlePrefix?: string;
  breadcrumbItems?: BreadcrumbsProps['items'];
  height?: number | string;
}

export const Header = (props: HeaderProps) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <HeaderWrapper height={props.height}>
      <StyledStack direction="row" alignItems="center">
        {props.backLink && (
          <StyledIconButton
            disableRipple
            onClick={() =>
              typeof props.backLink === 'number'
                ? navigate(props.backLink)
                : navigate(props.backLink as To)
            }>
            <ArrowBackIcon />
          </StyledIconButton>
        )}
        <StyledGrid>
          <StyledBox>
            {props.breadcrumbItems && !pathname.includes(PATHS.SETTINGS) && (
              <Breadcrumbs items={props.breadcrumbItems} />
            )}
          </StyledBox>
          <StyledWrapper>
            {props.title && (
              <CustomTooltip
                width={500}
                placement="bottom"
                title={props.title}
                {...(props.backLink === PATHS.COMPONENT_TAGS_MANAGE ||
                props.backLink === PATHS.ASSEMBLY_MANAGE_TAGS
                  ? { overflowWidth: 1000 }
                  : { overflowLineNumber: 1 })}>
                <HeaderTitle variant="h3" gutterBottom>
                  {`${props.titlePrefix ? props.titlePrefix + ' ' : ''}${
                    props.title
                  }`}
                </HeaderTitle>
              </CustomTooltip>
            )}

            {props.icon && (
              <LightTooltip
                title={props.iconText}
                placement="right-start"
                arrow={true}>
                <StyledIconButton disableRipple>{props.icon}</StyledIconButton>
              </LightTooltip>
            )}
          </StyledWrapper>
        </StyledGrid>
      </StyledStack>

      {props.actionBar && <ActionBarBox>{props.actionBar}</ActionBarBox>}
    </HeaderWrapper>
  );
};
